// extracted by mini-css-extract-plugin
module.exports =  {"sticky":"sticky__cPB64","topItems":"topItems__hP7k4","bottomItems":"bottomItems__jBWSY"};